import React from 'react'
import CheckedIcon from '../../components/Images/RadioSelected'
import UnCheckedIcon from '../../components/Images/RadioSelected'
import {
  ProgressArm1,
  ProgressArm2,
  ProgressDivOuter,
  ProgressDivInner,
  TopLevel,
  MidLevel,
  BottomLevel,
  CurrentLabel,
  MileStoneLabel,
  MileStoneAward,
  MileStoneAwardDummy,
  MobileLabelsContainer,
  StepLabelMobile
} from './style'


const TimeLineROW = ({ word_count, wordCountLabel, mileStone1, mileStone2,mileStone3, mileStone1Label, mileStone2Label,mileStone3Label, mileStone1Award, mileStone2Award,mileStone3Award}) => {
  const isMobile = window.screen.width < 600
  let remainingWordCount = word_count - mileStone1
  remainingWordCount = remainingWordCount < 0 ? 0 : remainingWordCount
  let remainingWordCount2 = word_count - mileStone2
  remainingWordCount2 = remainingWordCount2 < 0 ? 0 : remainingWordCount2
  return (
    <div>
      <MidLevel>
        <ProgressArm1 width={100 * (mileStone1 / mileStone3)}>
          <ProgressDivOuter>
            <ProgressDivInner width={(word_count / (mileStone1 / 100)) > 100 ? 100 : (word_count / (mileStone1 / 100))} />
          </ProgressDivOuter>
        </ProgressArm1>
        {word_count >= mileStone1 && <CheckedIcon />}
        {word_count < mileStone1 && <UnCheckedIcon />}
        <ProgressArm2 width={100 * ((mileStone2 - mileStone1) / mileStone3)}>
          <ProgressDivOuter>
            <ProgressDivInner width={(remainingWordCount / (mileStone2 - mileStone1) * 100) > 100 ? 100 : (remainingWordCount / (mileStone2 - mileStone1) * 100)} />
          </ProgressDivOuter>
        </ProgressArm2>
        {word_count >= mileStone2 && <CheckedIcon />}
        {word_count < mileStone2 && <UnCheckedIcon />}
        <ProgressArm2 width={100 * ((mileStone3 - mileStone2) / mileStone3)}>
          <ProgressDivOuter>
            <ProgressDivInner width={(remainingWordCount2 / (mileStone3 - mileStone2) * 100) > 100 ? 100 : (remainingWordCount2 / (mileStone3 - mileStone2) * 100)} />
          </ProgressDivOuter>
        </ProgressArm2>
        {word_count >= mileStone3 && <CheckedIcon />}
        {word_count < mileStone3 && <UnCheckedIcon />}
      </MidLevel>
      {!isMobile && <TopLevel>
        {/* <CurrentLabel>{wordCountLabel}</CurrentLabel> */}
        <MileStoneAwardDummy>just long long string</MileStoneAwardDummy>
        <MileStoneLabel>{mileStone1Label}🌟</MileStoneLabel>
        <MileStoneLabel>{mileStone2Label}🌟</MileStoneLabel>
        <MileStoneLabel>{mileStone3Label}🏆</MileStoneLabel>
      </TopLevel>}
      {!isMobile && <BottomLevel>
        <MileStoneAwardDummy>just a long long string</MileStoneAwardDummy>
        <MileStoneAward>{"+$" + mileStone1Award}</MileStoneAward>
        <MileStoneAward>{"+$" + mileStone2Award}</MileStoneAward>
        <MileStoneAward>{"+$" + mileStone3Award}</MileStoneAward>
      </BottomLevel>}
      {isMobile && (
        <MobileLabelsContainer>
          <StepLabelMobile>
          <MileStoneAwardDummy>just a</MileStoneAwardDummy>
          </StepLabelMobile>
          <StepLabelMobile>
            <MileStoneLabel>{mileStone1Label}🌟</MileStoneLabel>
            <MileStoneAward >{"+$" + mileStone1Award}</MileStoneAward>
          </StepLabelMobile>
          <StepLabelMobile>
            <MileStoneLabel>{mileStone2Label}🌟</MileStoneLabel>
            <MileStoneAward>{"+$" + mileStone2Award}</MileStoneAward>
          </StepLabelMobile>
          <StepLabelMobile>
            <MileStoneLabel>{mileStone3Label}🏆</MileStoneLabel>
            <MileStoneAward>{"+$" + mileStone3Award}</MileStoneAward>
          </StepLabelMobile>
        </MobileLabelsContainer>
      )}
    </div>
  )
}
export default TimeLineROW
